// PE-6108 — inline-styled email body fragment (no html/head/body wrapper)

export const RETURNING_PATIENT_APPOINTMENT_EMAIL_TEMPLATE = `
<div style="display:none;font-size:1px;line-height:1px;max-height:0;max-width:0;opacity:0;overflow:hidden;mso-hide:all;color:#ffffff;">
  {{preheaderText}}
</div>
<table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="margin:0;padding:0;width:100%;background-color:#e5e7eb;border-collapse:collapse;">
  <tr>
    <td align="center" style="padding:24px 16px;font-family:Arial,Helvetica,sans-serif;">
      <table role="presentation" width="600" cellspacing="0" cellpadding="0" border="0" style="width:100%;max-width:600px;background-color:#ffffff;border-collapse:collapse;border-radius:12px;">
        <tr>
          <td style="padding:32px;background-color:#0056b3;font-family:Arial,Helvetica,sans-serif;">
            <h1 style="margin:0;font-size:36px;font-weight:700;line-height:40px;color:#ffffff;">Appointment<br />Confirmed!</h1>
          </td>
        </tr>
        <tr>
          <td style="padding:32px;font-family:Arial,Helvetica,sans-serif;">
            <p style="margin:0 0 16px 0;font-size:18px;font-weight:700;line-height:28px;color:#111827;">
              Hi <span style="color:#007fc5;">{{patientName}}</span>,
            </p>
            <p style="margin:0 0 16px 0;font-size:16px;font-weight:400;line-height:24px;color:#111827;">
              Your <span style="font-weight:600;color:#007fc5;">{{appointmentType}}</span> appointment with <span style="font-weight:600;color:#007fc5;">Dr. {{providerName}}</span> has been scheduled for <span style="font-weight:600;color:#007fc5;">{{appointmentDate}}</span>, at <span style="font-weight:600;color:#007fc5;">{{appointmentTime}}</span>.
            </p>
            {{additionalNotesBlock}}
            <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="width:100%;border-collapse:collapse;background-color:#f1f5f9;border:1px solid #dbeafe;border-radius:12px;">
              <tr>
                <td style="padding:16px;">
                  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="width:100%;border-collapse:collapse;">
                    <tr>
                      <td style="padding:0 0 17px 0;border-bottom:1px solid #e5e7eb;">
                        <table role="presentation" cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;">
                          <tr>
                            <td width="48" height="48" align="center" valign="middle" style="width:48px;height:48px;background-color:#dbeafe;border-radius:24px;font-size:18px;line-height:48px;color:#007fc5;">&#128197;</td>
                            <td style="padding-left:16px;font-family:Arial,Helvetica,sans-serif;">
                              <p style="margin:0 0 4px 0;font-size:12px;line-height:16px;color:#4b5961;">Date</p>
                              <p style="margin:0;font-size:16px;font-weight:600;line-height:24px;color:#111827;">{{appointmentDate}}</p>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding:17px 0;border-bottom:1px solid #e5e7eb;">
                        <table role="presentation" cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;">
                          <tr>
                            <td width="48" height="48" align="center" valign="middle" style="width:48px;height:48px;background-color:#dbeafe;border-radius:24px;font-size:18px;line-height:48px;color:#007fc5;">&#128339;</td>
                            <td style="padding-left:16px;font-family:Arial,Helvetica,sans-serif;">
                              <p style="margin:0 0 4px 0;font-size:12px;line-height:16px;color:#4b5961;">Time</p>
                              <p style="margin:0;font-size:16px;font-weight:600;line-height:24px;color:#111827;">{{appointmentTime}}</p>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding:17px 0;border-bottom:1px solid #e5e7eb;">
                        <table role="presentation" cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;">
                          <tr>
                            <td width="48" height="48" align="center" valign="middle" style="width:48px;height:48px;background-color:#dbeafe;border-radius:24px;font-size:18px;line-height:48px;color:#007fc5;">&#128205;</td>
                            <td style="padding-left:16px;font-family:Arial,Helvetica,sans-serif;">
                              <p style="margin:0 0 4px 0;font-size:12px;line-height:16px;color:#4b5961;">Location</p>
                              <p style="margin:0;font-size:16px;font-weight:600;line-height:24px;color:#111827;">{{appointmentLocation}}</p>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding:17px 0 0 0;">
                        <table role="presentation" cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;">
                          <tr>
                            <td width="48" height="48" align="center" valign="middle" style="width:48px;height:48px;background-color:#dbeafe;border-radius:24px;font-size:18px;line-height:48px;color:#007fc5;">&#128222;</td>
                            <td style="padding-left:16px;font-family:Arial,Helvetica,sans-serif;">
                              <p style="margin:0 0 4px 0;font-size:12px;line-height:16px;color:#4b5961;">Contact</p>
                              <p style="margin:0;font-size:16px;font-weight:600;line-height:24px;color:#111827;">{{contactPhone}}</p>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
            {{tenantDepartmentBlock}}
            <p style="margin:8px 0 16px 0;padding-top:8px;font-size:14px;line-height:20px;color:#4b5961;text-align:center;font-family:Arial,Helvetica,sans-serif;">
              We look forward to seeing you!
            </p>
            <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="width:100%;border-collapse:collapse;background-color:#f8fafc;border-radius:12px;">
              <tr>
                <td style="padding:16px;">
                  <table role="presentation" cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;">
                    <tr>
                      <td width="40" height="40" align="center" valign="middle" style="width:40px;height:40px;background-color:#0056b3;border-radius:20px;font-size:18px;line-height:40px;color:#ffffff;">&#128172;</td>
                      <td style="padding-left:16px;font-family:Arial,Helvetica,sans-serif;">
                        <p style="margin:0;font-size:14px;line-height:20px;color:#4b5961;">
                          If you have any questions or need to reschedule, please contact us.
                        </p>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td height="65" style="height:65px;background-color:#f9fafb;border-top:1px solid #f3f4f6;font-size:0;line-height:0;">&nbsp;</td>
        </tr>
      </table>
    </td>
  </tr>
</table>
`.trim();
